import gql from 'graphql-tag'

export default gql`
    mutation segment($ID: String!, $Action: String!, $Data: String!) {
        segment(ID: $ID, Action: $Action, Data: $Data)
    }
`
